import "./ConfirmDialog.css";

/**
 * A small, reusable confirm/cancel dialog - for anywhere a destructive or
 * hard-to-undo action needs a deliberate second step, without falling
 * back to the browser's own window.confirm() (which looks like a browser
 * warning, not part of the app).
 */
export default function ConfirmDialog({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  isBusy = false,
  onConfirm,
  onCancel,
}) {
  return (
    <div className="confirm-dialog__overlay" role="alertdialog" aria-modal="true" aria-label={title}>
      <div className="confirm-dialog">
        <h2 className="confirm-dialog__title">{title}</h2>
        {message ? <p className="confirm-dialog__message">{message}</p> : null}
        <div className="confirm-dialog__actions">
          <button type="button" onClick={onCancel} disabled={isBusy} className="confirm-dialog__cancel-btn">
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isBusy}
            className={`confirm-dialog__confirm-btn${danger ? " confirm-dialog__confirm-btn--danger" : ""}`}
          >
            {isBusy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}